/* eslint-disable react/require-default-props */
// @ts-nocheck
import React, { Fragment, useEffect, useState } from 'react';
import ehDiaUtil from '@lfreneda/eh-dia-util';
import moment from 'moment';
import 'moment/locale/pt-br';
import { BaseTerritoryData } from 'services/basesServices';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';

import { useMediaQuery } from 'react-responsive';
import DayCard from './DayCard';
import DayCardMobile from './DayCardMobile';

import {
  CalendarContainer,
  Header,
  MonthYearTitle,
  SelectMonth,
  DayContainer,
  MonthControls,
  ButtonChangeMonth,
  AnalystyButton,
} from './styles';

type CalendarProps = {
  handleDateChange: (date: string, isFixedRoute: boolean) => void;
  initialSelectedDate?: string;
  clickAnalyst?: () => void;
  baseTerritory?: BaseTerritoryData;
};

const Calendar: React.FC<CalendarProps> = ({
  handleDateChange,
  initialSelectedDate = '',
  clickAnalyst,
  baseTerritory = null,
}) => {
  moment.locale('pt-br');
  const [currentDate, setCurrentDate] = useState(moment());
  const [currentWeek, setCurrentWeek] = useState(moment().startOf('isoWeek'));
  const [isFixedRouteSelected, setIsFixedRouteSelected] = useState(true);
  const [days, setDays] = useState<
    {
      day: moment.Moment;
      status: string;
      isToday: boolean;
      isSelected: boolean;
    }[]
  >([]);
  const [selectedDate, setSelectedDate] = useState<moment.Moment | null>(
    initialSelectedDate ? moment(initialSelectedDate, 'YYYY-MM-DD') : null
  );

  const isMobile = useMediaQuery({ maxWidth: 768 });

  // Verifica se o dia é um final de semana
  const isWeekend = (day: moment.Moment): boolean => {
    return day.isoWeekday() === 6 || day.isoWeekday() === 7;
  };

  // Verifica se o dia é um feriado
  const isHoliday = (day: moment.Moment): boolean => {
    // Você pode usar a biblioteca 'eh-dia-util' ou outra API para verificar feriados
    const businessDay = day.format('YYYY-MM-DD');
    return !ehDiaUtil(businessDay);
  };

  // Verifica se o dia ultrapassa 90 dias a partir de hoje
  const isAfter90Days = (day: moment.Moment): boolean => {
    const limitDay = moment().add(90, 'days');
    return day.isAfter(limitDay, 'day');
  };

  const isParamNewRulesActive = (): boolean => {
    return baseTerritory?.useNewRefuelRule || false;
  };

  const isRouteDay = (day: moment.Moment): boolean => {
    const isoWeekday = day.isoWeekday(); // 1 (Segunda) a 7 (Domingo)
    let isRoute = false;

    switch (isoWeekday) {
      case 1:
        isRoute = !!baseTerritory?.monday;
        break;
      case 2:
        isRoute = !!baseTerritory?.tuesday;
        break;
      case 3:
        isRoute = !!baseTerritory?.wednesday;
        break;
      case 4:
        isRoute = !!baseTerritory?.thursday;
        break;
      case 5:
        isRoute = !!baseTerritory?.friday;
        break;
      case 6:
        isRoute = !!baseTerritory?.saturday;
        break;
      case 7:
        isRoute = !!baseTerritory?.sunday;
        break;
      default:
        isRoute = false;
    }

    return isRoute;
  };

  const isTomorrow = (day: moment.Moment): boolean => {
    return day.isSame(moment().add(1, 'day'), 'day');
  };

  const isCurrentMonth = (day: moment.Moment): boolean => {
    return day.isSame(moment(), 'month');
  };

  const isSaturday = (day: moment.Moment): boolean => {
    return day.isoWeekday() === 6;
  };

  const isFriday = (day: moment.Moment): boolean => {
    return day.isoWeekday() === 5;
  };

  const getNextMonday = (): moment.Moment => {
    return moment().isoWeekday(8);
  };

  const isTodaySaturday = (): boolean => {
    return moment().isoWeekday() === 6;
  };

  const isTodaySunday = (): boolean => {
    return moment().isoWeekday() === 7;
  };

  const isStopHourOperationWeek = (): any => {
    const currentHour = moment(new Date(), 'h:mma');
    const disableOperation = isParamNewRulesActive()
      ? moment('12:00pm', 'h:mma')
      : moment('16:00pm', 'h:mma');

    return currentHour.isAfter(disableOperation);
  };

  const isStopHourOperationSaturday = (): any => {
    const currentHour = moment(new Date(), 'h:mma');
    const disableOperation = isParamNewRulesActive()
      ? moment('12:00pm', 'h:mma')
      : moment('16:00pm', 'h:mma');

    return currentHour.isAfter(disableOperation);
  };

  const getSugestDay = (): moment.Moment => {
    const todayDate = moment();
    let sugestDay = todayDate.clone();

    let qtdDaysControl =
      isStopHourOperationWeek() || isWeekend(todayDate) || isHoliday(todayDate)
        ? 4
        : 3;

    let newDay = todayDate.clone();
    for (let i = 1; i <= qtdDaysControl; i += 1) {
      if (
        !todayDate.isSame(newDay, 'day') &&
        isHoliday(newDay) &&
        !isWeekend(newDay)
      ) {
        qtdDaysControl += 1;
      }
      if (!todayDate.isSame(newDay, 'day') && isWeekend(newDay)) {
        qtdDaysControl += 1;
      }

      newDay = newDay.add(1, 'days');
    }

    while (isWeekend(newDay) || isHoliday(newDay)) {
      newDay = newDay.add(1, 'days');
    }

    sugestDay = newDay.clone();
    return sugestDay;
  };

  // Verifica se o dia está antes do dia sugerido
  const isBeforeSugestDay = (day: moment.Moment): boolean => {
    const sugestDay = getSugestDay();
    return day.isBefore(sugestDay, 'day');
  };

  useEffect(() => {
    if (initialSelectedDate) {
      setSelectedDate(moment(initialSelectedDate, 'YYYY-MM-DD'));
    } else {
      setSelectedDate(null);
    }
  }, [initialSelectedDate]);

  const updateDaysForWeek = (week: moment.Moment): void => {
    const startOfWeek = week.clone().startOf('isoWeek');
    const today = moment();
    const daysArray = [];

    for (let i = 0; i < 7; i += 1) {
      const day = startOfWeek.clone().add(i, 'days');
      let status = 'fora_de_rota';

      if (day.isSameOrBefore(today, 'day')) {
        status = 'indisponivel';
      } else if (isAfter90Days(day)) {
        status = 'indisponivel';
      } else if (isHoliday(day) && day.isoWeekday() !== 6) {
        status = 'indisponivel';
      } else if (isWeekend(day) || isHoliday(day)) {
        status = 'indisponivel';
      } else if (isBeforeSugestDay(day) && !isRouteDay(day)) {
        status = 'indisponivel';
      } else if (!isRouteDay(day)) {
        status = 'fora_de_rota';
      } else {
        status = 'em_rota';
      }

      // Condições adicionais baseadas no código antigo
      if (isParamNewRulesActive()) {
        if (isBeforeSugestDay(day)) {
          if (!isRouteDay(day)) {
            status = 'indisponivel';
          } else if (
            isTomorrow(day) &&
            (isWeekend(today) || isHoliday(today))
          ) {
            status = 'indisponivel';
          } else if (
            (day.format('dddd').toLowerCase() === 'segunda-feira' ||
              day.format('dddd').toLowerCase() === 'domingo') &&
            (isWeekend(today) || isHoliday(today))
          ) {
            status = 'indisponivel';
          } else if (isTomorrow(day) && isStopHourOperationWeek()) {
            status = 'indisponivel';
          } else if (isHoliday(today)) {
            status = 'indisponivel';
          }
        }

        if (isHoliday(day) && day.format('dddd').toLowerCase() !== 'sábado') {
          status = 'indisponivel';
        }

        if (!isRouteDay(day) && day.format('dddd').toLowerCase() === 'sábado') {
          status = 'indisponivel';
        }

        if (
          isTodaySaturday() &&
          baseTerritory?.monday === true &&
          day.isSame(getNextMonday(), 'day') &&
          isStopHourOperationSaturday() === true &&
          status === 'em_rota' &&
          isCurrentMonth(day)
        ) {
          status = 'fora_de_rota';
        }

        if (
          isTodaySunday() &&
          baseTerritory?.monday === true &&
          day.isSame(getNextMonday(), 'day') &&
          status === 'em_rota' &&
          isCurrentMonth(day)
        ) {
          status = 'fora_de_rota';
        }

        if (
          isFriday(today) &&
          baseTerritory?.saturday === true &&
          isSaturday(day) &&
          isStopHourOperationSaturday() &&
          status === 'em_rota'
        ) {
          status = 'fora_de_rota';
        }
      }

      daysArray.push({
        day,
        status,
        isToday: day.isSame(today, 'day'),
        isSelected: selectedDate ? day.isSame(selectedDate, 'day') : false,
      });
    }

    setDays(daysArray);
  };

  useEffect(() => {
    updateDaysForWeek(currentWeek);
  }, [currentWeek, selectedDate, baseTerritory]);

  const nextWeek = (): void => {
    const nextWeekNew = currentWeek.clone().add(1, 'week');
    setCurrentWeek(nextWeekNew);
    setCurrentDate(nextWeekNew.clone());
  };

  const prevWeek = (): void => {
    const prevWeekNew = currentWeek.clone().subtract(1, 'week');
    setCurrentWeek(prevWeekNew);
    setCurrentDate(prevWeekNew.clone());
  };

  const handleDayClick = (day: moment.Moment, status: string): void => {
    if (status !== 'indisponivel') {
      const formattedDate = day.format('YYYY-MM-DD');
      setSelectedDate(day);
      setDays((prevDays) =>
        prevDays.map((dayObj) => ({
          ...dayObj,
          isSelected: dayObj.day.isSame(day, 'day'),
        }))
      );

      handleDateChange(formattedDate, status === 'em_rota');
      setIsFixedRouteSelected(status === 'em_rota');
    }
  };

  const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const newMonth = parseInt(e.target.value, 10);
    const updatedDate = moment(currentDate).month(newMonth).startOf('month');
    setCurrentDate(updatedDate);
    if (updatedDate.isSame(moment(), 'month')) {
      setCurrentWeek(moment().startOf('isoWeek'));
    } else {
      setCurrentWeek(updatedDate.clone().startOf('isoWeek'));
    }
    updateDaysForWeek(updatedDate.clone().startOf('isoWeek'));
  };

  return (
    <CalendarContainer>
      <Header>
        <MonthYearTitle>
          <SelectMonth value={currentDate.month()} onChange={handleMonthChange}>
            {moment.months().map((month, index) => (
              <option key={month} value={index}>
                {month}
              </option>
            ))}
          </SelectMonth>
        </MonthYearTitle>
        {!isMobile && (
          <>
            {!isFixedRouteSelected && (
              <AnalystyButton onClick={clickAnalyst}>
                Data sujeita a análise
              </AnalystyButton>
            )}
          </>
        )}
        <MonthControls>
          <ButtonChangeMonth onClick={prevWeek}>
            <IoIosArrowBack size={24} />
          </ButtonChangeMonth>
          <ButtonChangeMonth onClick={nextWeek}>
            <IoIosArrowForward size={24} />
          </ButtonChangeMonth>
        </MonthControls>
      </Header>
      {isMobile && (
        <>
          {!isFixedRouteSelected && (
            <AnalystyButton onClick={clickAnalyst}>
              Data sujeita a análise
            </AnalystyButton>
          )}
        </>
      )}
      <DayContainer>
        {days.map((dayObj) => (
          <Fragment key={dayObj.da}>
            {!isMobile && (
              <DayCard
                status={dayObj.status}
                onClick={() => handleDayClick(dayObj.day, dayObj.status)}
                weekDay={
                  dayObj.day
                    .format('dddd')
                    .split('-')[0]
                    .charAt(0)
                    .toUpperCase() +
                  dayObj.day.format('dddd').split('-')[0].slice(1)
                }
                day={dayObj.day.format('DD')}
                isToday={dayObj.isToday}
                isSelected={dayObj.isSelected}
              />
            )}
            {isMobile && (
              <DayCardMobile
                status={dayObj.status}
                onClick={() => handleDayClick(dayObj.day, dayObj.status)}
                weekDay={
                  dayObj.day
                    .format('dddd')
                    .split('-')[0]
                    .charAt(0)
                    .toUpperCase() +
                  dayObj.day.format('dddd').split('-')[0].slice(1)
                }
                day={dayObj.day.format('DD')}
                isToday={dayObj.isToday}
                isSelected={dayObj.isSelected}
              />
            )}
          </Fragment>
        ))}
      </DayContainer>
    </CalendarContainer>
  );
};

export default Calendar;
